__turbopack_context__.v({
  "drawerContainer": "Dco5AG_drawerContainer",
  "handle": "Dco5AG_handle",
});
